import React, { useContext } from 'react';
import { cellValueHighLight } from '@src/utils/tableUtils';
import { Tabs } from '@uhg-abyss/web/ui/Tabs';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { useLazyGetReportsQuery } from '@src/store/services/cdb/onlineServices';
import { useLazyGetGPSReportsQuery } from '@src/store/services/gps/onlineServices';
import { FileContext } from '@src/routes/Routes';
import { Table, FILL_WIDTH_COLUMNS_CSS } from '@src/common/Table';

export const PCPErrorReport = () => {
  const router = useRouter();
  const { service } = router.getRouteParams();
  const { fileData } = useContext(FileContext);
  const reportTypeCust = 'PCPE';
  const reportTypeElig = 'PCPI';
  const reqData = router.getRouteParams();

  const [modifiedReqData, setModifiedReqData] = React.useState({
    ...reqData,
    reportType: reportTypeCust,
  });
  const myRef = React.useRef<HTMLElement | null>(null);

  const custcolumns = React.useMemo(() => {
    return [
      {
        Header: 'Employee ID',
        accessor: 'employeeId',
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        minWidth: 50,
        width: 50,
        Cell: ({ row, value }) => {
          return cellValueHighLight({
            value,
            fileData,
            typeValue: row?.original?.multiTransId,
          });
        },
      },
      {
        Header: 'Name',
        accessor: 'name',
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        minWidth: 65,
        width: 65,
        Cell: ({ row, value }) => {
          return cellValueHighLight({
            value,
            fileData,
            typeValue: row?.original?.multiTransId,
          });
        },
      },

      {
        Header: 'Birth Date',
        accessor: 'birthDate',
        canToggleVisibilty: false,
        isHiddenByDefault: false,
        minWidth: 40,
        width: 40,
        Cell: ({ row, value }) => {
          return cellValueHighLight({
            value,
            fileData,
            typeValue: row?.original?.multiTransId,
          });
        },
      },
      {
        Header: 'Rel',
        accessor: 'rel',
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        minWidth: 20,
        width: 20,
        Cell: ({ row, value }) => {
          return cellValueHighLight({
            value,
            fileData,
            typeValue: row?.original?.multiTransId,
          });
        },
      },
      {
        Header: 'Provider ID',
        accessor: 'providerId',
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        minWidth: 45,
        width: 45,
        Cell: ({ row, value }) => {
          return cellValueHighLight({
            value,
            fileData,
            typeValue: row?.original?.multiTransId,
          });
        },
      },
      {
        Header: 'Location Sequence no',
        accessor: 'locationSequenceNo',
        minWidth: 40,
        width: 40,
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        Cell: ({ row, value }) => {
          return cellValueHighLight({
            value,
            fileData,
            typeValue: row?.original?.multiTransId,
          });
        },
      },
      {
        Header: 'CDB Error Code-Detail',
        accessor: 'cdbErrorCodeDetail',
        minWidth: 100,
        width: 100,
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        Cell: ({ row, value }) => {
          return cellValueHighLight({
            value,
            fileData,
            typeValue: row?.original?.multiTransId,
          });
        },
      },
      {
        Header: 'CES Error Code-Detail',
        accessor: 'cesErrorCodeDetail',
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        minWidth: 100,
        width: 100,
        Cell: ({ row, value }) => {
          return cellValueHighLight({
            value,
            fileData,
            typeValue: row?.original?.multiTransId,
          });
        },
      },
      {
        Header: 'NDB Error Code-Detail',
        accessor: 'ndbErrorCodeDetail',
        minWidth: 100,
        width: 100,
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        Cell: ({ row, value }) => {
          return cellValueHighLight({
            value,
            fileData,
            typeValue: row?.original?.multiTransId,
          });
        },
      },
      {
        Header: 'UP2S Error Code-Detail',
        accessor: 'up2sErrorCodeDetail',
        minWidth: 100,
        Cell: ({ row, value }) => {
          return cellValueHighLight({
            value,
            fileData,
            typeValue: row?.original?.multiTransId,
          });
        },
        width: 100,
        canToggleVisibilty: true,
        isHiddenByDefault: false,
      },
    ];
  }, []);

  const eligcolumns = React.useMemo(() => {
    return [
      {
        Header: 'Employee ID',
        accessor: 'employeeId',
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        minWidth: 50,
        width: 50,
      },
      {
        Header: 'Name',
        accessor: 'name',
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        minWidth: 65,
        width: 65,
      },

      {
        Header: 'Birth Date',
        accessor: 'birthDate',
        canToggleVisibilty: false,
        isHiddenByDefault: false,
        minWidth: 40,
        width: 40,
      },
      {
        Header: 'Rel',
        accessor: 'rel',
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        minWidth: 20,
        width: 20,
      },
      {
        Header: 'Provider ID',
        accessor: 'providerId',
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        minWidth: 45,
        width: 45,
      },
      {
        Header: 'Location Sequence no',
        accessor: 'locationSequenceNo',
        minWidth: 40,
        width: 40,
        canToggleVisibilty: true,
        isHiddenByDefault: false,
      },
      {
        Header: 'CDB Error Code-Detail',
        accessor: 'cdbErrorCodeDetail',
        minWidth: 100,
        width: 100,
        canToggleVisibilty: true,
        isHiddenByDefault: false,
      },
      {
        Header: 'CES Error Code-Detail',
        accessor: 'cesErrorCodeDetail',
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        minWidth: 100,
        width: 100,
      },
      {
        Header: 'NDB Error Code-Detail',
        accessor: 'ndbErrorCodeDetail',
        minWidth: 100,
        width: 100,
        canToggleVisibilty: true,
        isHiddenByDefault: false,
      },
      {
        Header: 'UP2S Error Code-Detail',
        accessor: 'up2sErrorCodeDetail',
        minWidth: 100,
        width: 100,
        canToggleVisibilty: true,
        isHiddenByDefault: false,
      },
    ];
  }, []);

  return (
    <div ref={myRef}>
      <Tabs
        title="Tabs Sandbox"
      >
        <Tabs.Tab label="Eligibility Analyst Error" value="eligibility">
          {/* <DataTable hideHeader tableState={dataTablePropsCustPCP} /> */}
          <Table
            columns={eligcolumns}
            dataKey="eligibilityPCPTable"
            fetch={
              service === 'gps'
                ? useLazyGetGPSReportsQuery
                : useLazyGetReportsQuery
            }
            requestParams={{
              ...reqData,
              ...fileData,
              allDate: 'false',
              reportType: reportTypeElig,
            }}
            showGlobalFilter={false}
            tableCss={FILL_WIDTH_COLUMNS_CSS}
          />
        </Tabs.Tab>
        <Tabs.Tab label="Customer Error" value="customer">
          {/*   <DataTable hideHeader tableState={dataTablePropsSubPCP} /> */}
          <Table
            columns={custcolumns}
            dataKey="custErrorPCPTable"
            fetch={
              service === 'gps'
                ? useLazyGetGPSReportsQuery
                : useLazyGetReportsQuery
            }
            requestParams={{
              ...modifiedReqData,
              ...fileData,
              allDate: 'false',
              reportType: reportTypeCust,
            }}
            showGlobalFilter={false}
            tableCss={FILL_WIDTH_COLUMNS_CSS}
          />
        </Tabs.Tab>
      </Tabs>
    </div>
  );
};
